import { createSlice } from "@reduxjs/toolkit";
import {
  createApiThunkPrivate,
  createApiThunkPrivateImage,
  createExtraReducersForThunk,
} from "../../utils/apiThunk";

const initialState = {
  value: 0,
  loading: false,
  error: "",
  getQuestionBySetData: {},
  getStudentListByAdminData: {},
  createNewStudentData: {},
  getAllUserSelectedData: {},
  getBoardListData: {},
  getEducationListData: {},
  deleteStudentData: {},
  updateStudentData: {},
  getNotificationData: {},
  sendNotificationForUserData: {},
  uploadImageData: {},
  getAllDonerData: {},
  deleteBoardData: {},
  createBoardData: {},
  getTicketListData: {},
  getMsgListByTicketIdData: {},
  replyByAdminForTicketData: {},
  updateAdminPasswordData: {},
  getLoginHistoryListData: {},
  deleteQuestionData: {},
  getQuestionByIdData: {},
  getLanguageListForAdminData: {},
  createNewQuestionData: {},
  getIntroductionByIdData: {},
  updateIntroductionData: {},
  getPageListData: {},
  getPageByIdData: {},
  updatePageData: {},
  createNewPageData: {},
  getSkillIndicatorListData: {},
  createNewSkillIndicatorData: {},
  deleteSkillIndicatorData: {},
  updateSkillIndicatorData: {},
  resolveTicketData: {},
  addCategoryData: {},
  updateCategoryData: {},
  getCategoryListData: {},
  deleteCategoryData: {},
  getAllCategoryData: {},
  getQuestionListData: {},
  LauguageSettingDataByCategoryIds: {},
  getSplashScreenListData:{},
  addSplashScreenData:{},
  updateSplashScreenData:{},
  deleteSplashScreenData:{},
  updateSplashScreenStatusData:{}
};
export const getQuestionBySet = createApiThunkPrivate(
  "getQuestionBySet",
  "/getQuestionBySet"
);
export const getQuestionList = createApiThunkPrivate(
  "getQuestionList",
  "/getQuestionList"
);
export const getStudentListByAdmin = createApiThunkPrivate(
  "getStudentListByAdmin",
  "/getStudentListByAdmin"
);
export const createNewStudent = createApiThunkPrivate(
  "createNewStudent",
  "/createNewStudent"
);
export const getAllUserSelected = createApiThunkPrivate(
  "getAllUserSelected",
  "/getAllUserSelected"
);
export const getBoardList = createApiThunkPrivate(
  "getBoardList",
  "/getCourseList"
);
export const getEducationList = createApiThunkPrivate(
  "getEducationList",
  "/getEducationList"
);
export const deleteStudent = createApiThunkPrivate(
  "deleteStudent",
  "/deleteStudent"
);
export const updateStudent = createApiThunkPrivate(
  "updateStudent",
  "/updateStudent"
);
export const getNotification = createApiThunkPrivate(
  "getNotification",
  "/getNotification"
);
export const sendNotificationForUser = createApiThunkPrivate(
  "sendNotificationForUser",
  "/sendNotificationForUser"
);
export const uploadImage = createApiThunkPrivateImage(
  "uploadImage",
  "/api/upload"
);
export const uploadAudio = createApiThunkPrivateImage(
  "uploadImage",
  "/api/upload-audio"
);

export const getAllDoner = createApiThunkPrivate("getAllDoner", "/getAllDoner");
export const deleteBoard = createApiThunkPrivate(
  "deleteBoard",
  "/deleteCourse"
);
export const resolveTicket = createApiThunkPrivate(
  "resolveTicket",
  "/resolvedTicket"
);

export const createBoard = createApiThunkPrivate(
  "createBoard",
  "/createCourse"
);
export const getTicketList = createApiThunkPrivate(
  "getTicketList",
  "/getTicketList"
);
export const getMsgListByTicketId = createApiThunkPrivate(
  "getMsgListByTicketId",
  "/getMsgListByTicketId"
);
export const replyByAdminForTicket = createApiThunkPrivate(
  "replyByAdminForTicket",
  "/replyByAdminForTicket"
);
export const updateAdminPassword = createApiThunkPrivate(
  "updateAdminPassword",
  "/updateAdminPassword"
);
export const getLoginHistoryList = createApiThunkPrivate(
  "getLoginHistoryList",
  "/getLoginHistoryList"
);
export const deleteQuestion = createApiThunkPrivate(
  "deleteQuestion",
  "/deleteQuestion"
);
export const getQuestionById = createApiThunkPrivate(
  "getQuestionById",
  "/getQuestionById"
);
export const getLanguageListForAdmin = createApiThunkPrivate(
  "getLanguageListForAdmin",
  "/getLanguageListForAdmin"
);
export const createNewQuestion = createApiThunkPrivate(
  "createNewQuestion",
  "/createNewQuestion"
);
export const getIntroductionById = createApiThunkPrivate(
  "getIntroductionById",
  "/getIntroductionById"
);
export const updateIntroduction = createApiThunkPrivate(
  "updateIntroduction",
  "/updateIntroduction"
);
export const getPageList = createApiThunkPrivate("getPageList", "/getPageList");
export const getPageById = createApiThunkPrivate("getPageById", "/getPageById");
export const updatePage = createApiThunkPrivate("updatePage", "/updatePage");
export const createNewPage = createApiThunkPrivate(
  "createNewPage",
  "/createNewPage"
);
export const getSkillIndicatorList = createApiThunkPrivate(
  "getSkillIndicatorList",
  "/getSkillIndicatorList"
);
export const createNewSkillIndicator = createApiThunkPrivate(
  "createNewSkillIndicator",
  "/createNewSkillIndicator"
);
export const deleteSkillIndicator = createApiThunkPrivate(
  "deleteSkillIndicator",
  "/deleteSkillIndicator"
);
export const updateSkillIndicator = createApiThunkPrivate(
  "updateSkillIndicator",
  "/updateSkillIndicator"
);
export const addCategory = createApiThunkPrivate(
  "addCategory",
  "/createCategory"
);
export const updateCategory = createApiThunkPrivate(
  "updateCategory",
  "/updateCategory"
);
export const getCategoryList = createApiThunkPrivate(
  "getCategoryList",
  "/listCategories"
);
export const getAllCategories = createApiThunkPrivate(
  "getAllcategories",
  "/getAllCategories"
);
export const LauguageSettingByCategoryIds = createApiThunkPrivate(
  "LauguageSettingByCategoryIds",
  "/getLanguageSetting2ByCategoryId"
);
export const getSplashScreenList=createApiThunkPrivate('getSplashScreenList','/getSplashScreenList')
export const addSplashScreen=createApiThunkPrivate('addSplashScreen','/addSplashScreen')
export const updateSplashScreen=createApiThunkPrivate('updateSplashScreen','/updateSplashScreen')
export const updateSplashScreenStatus=createApiThunkPrivate('updateSplashScreenStatus','/updateSplashScreenStatus')
export const deleteSplashScreen=createApiThunkPrivate('deleteSplashScreen','/deleteSplashScreen')
export const QuestionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createExtraReducersForThunk(
      builder,
      getQuestionBySet,
      "getQuestionBySetData"
    );
    createExtraReducersForThunk(
      builder,
      getQuestionList,
      "getQuestionListData"
    );
    createExtraReducersForThunk(
      builder,
      getStudentListByAdmin,
      "getStudentListByAdminData"
    );
    createExtraReducersForThunk(
      builder,
      createNewStudent,
      "createNewStudentData"
    );
    createExtraReducersForThunk(
      builder,
      getAllUserSelected,
      "getAllUserSelectedData"
    );
    createExtraReducersForThunk(builder, getBoardList, "getBoardListData");
    createExtraReducersForThunk(
      builder,
      getEducationList,
      "getEducationListData"
    );
    createExtraReducersForThunk(builder, deleteStudent, "deleteStudentData");
    createExtraReducersForThunk(builder, updateStudent, "updateStudentData");
    createExtraReducersForThunk(
      builder,
      getNotification,
      "getNotificationData"
    );
    createExtraReducersForThunk(
      builder,
      sendNotificationForUser,
      "sendNotificationForUserData"
    );
    createApiThunkPrivateImage(builder, uploadImage, "uploadImageData");
    createExtraReducersForThunk(builder, getAllDoner, "getAllDonerData");
    createExtraReducersForThunk(builder, deleteBoard, "deleteBoardData");
    createExtraReducersForThunk(builder, resolveTicket, "resolveTicketData");

    createExtraReducersForThunk(builder, createBoard, "createBoardData");
    createExtraReducersForThunk(builder, getTicketList, "getTicketListData");
    createExtraReducersForThunk(
      builder,
      getMsgListByTicketId,
      "getMsgListByTicketIdData"
    );
    createExtraReducersForThunk(
      builder,
      replyByAdminForTicket,
      "replyByAdminForTicketData"
    );
    createExtraReducersForThunk(
      builder,
      updateAdminPassword,
      "updateAdminPasswordData"
    );
    createExtraReducersForThunk(
      builder,
      getLoginHistoryList,
      "getLoginHistoryListData"
    );
    createExtraReducersForThunk(builder, deleteQuestion, "deleteQuestionData");
    createExtraReducersForThunk(
      builder,
      getQuestionById,
      "getQuestionByIdData"
    );
    createExtraReducersForThunk(
      builder,
      getLanguageListForAdmin,
      "getLanguageListForAdminData"
    );
    createExtraReducersForThunk(
      builder,
      createNewQuestion,
      "createNewQuestionData"
    );
    createExtraReducersForThunk(
      builder,
      getIntroductionById,
      "getIntroductionByIdData"
    );
    createExtraReducersForThunk(
      builder,
      updateIntroduction,
      "updateIntroductionData"
    );
    createExtraReducersForThunk(builder, getPageList, "getPageListData");
    createExtraReducersForThunk(builder, getPageById, "getPageByIdData");
    createExtraReducersForThunk(builder, updatePage, "updatePageData");
    createExtraReducersForThunk(builder, createNewPage, "createNewPageData");
    createExtraReducersForThunk(
      builder,
      getSkillIndicatorList,
      "getSkillIndicatorListData"
    );
    createExtraReducersForThunk(
      builder,
      createNewSkillIndicator,
      "createNewSkillIndicatorData"
    );
    createExtraReducersForThunk(
      builder,
      deleteSkillIndicator,
      "deleteSkillIndicatorData"
    );
    createExtraReducersForThunk(
      builder,
      updateSkillIndicator,
      "updateSkillIndicatorData"
    );
    createExtraReducersForThunk(
      builder,
      getCategoryList,
      "getCategoryListData"
    );
    createExtraReducersForThunk(builder, addCategory, "addCategoryData");
    createExtraReducersForThunk(builder, updateCategory, "updateCategoryData");
    createExtraReducersForThunk(
      builder,
      getAllCategories,
      "getAllCategoryData"
    );
    createExtraReducersForThunk(
      builder,
      LauguageSettingByCategoryIds,
      "LauguageSettingDataByCategoryIds"
    );
    ////Splash Screen
    createExtraReducersForThunk(builder, getSplashScreenList, 'getSplashScreenListData')
    createExtraReducersForThunk(builder,addSplashScreen,'addSplashScreenData')
    createExtraReducersForThunk(builder,updateSplashScreen,'updateSplashScreenData')
    createExtraReducersForThunk(builder,deleteSplashScreen,'deleteSplashScreenData')
    createExtraReducersForThunk(builder,updateSplashScreenStatus,'updateSplashScreenStatusData')
  },
});

export default QuestionSlice.reducer;
